import { digitsOnly, joinSearchFields, normalizeSearchText } from './searchText.js'

/**
 * Canonical member matching.
 *
 * Every member-search surface — the check-in endpoint, the admin command
 * palette, the SubKrewe pickers, the member tables — normalizes and matches
 * through here. Before this existed there were ten hand-rolled
 * `.toLowerCase().includes()` predicates over four different field sets, so the
 * same query returned different people depending on where you typed it.
 *
 * Matching itself is entity-neutral and lives in searchText.ts; this module
 * only owns which member fields are searchable.
 */

/**
 * The canonical searchable field set. Anything not listed here is not
 * findable anywhere in the app — add fields to this interface rather than to a
 * single call site, which is how `displayName` ended up searchable at check-in
 * and nowhere else.
 */
export interface MemberSearchFields {
  name?: string | null
  displayName?: string | null
  email?: string | null
  phone?: string | null
  subkreweName?: string | null
}

/** Build the blob a query is tested against for one member. */
export function buildMemberSearchText(fields: MemberSearchFields): string {
  return joinSearchFields([
    normalizeSearchText(fields.name),
    normalizeSearchText(fields.displayName),
    normalizeSearchText(fields.email),
    normalizeSearchText(fields.phone),
    digitsOnly(fields.phone),
    normalizeSearchText(fields.subkreweName),
  ])
}
